import React from 'react';
import { BarChart, Users, Book } from 'lucide-react';

const EmploymentStats = ({ emploi }) => {
  const coursParJour = {};
  emploi.cours.forEach(cours => {
    coursParJour[cours.jour] = (coursParJour[cours.jour] || 0) + 1;
  });

  const moduleCount = new Set(emploi.cours.map(c => c.module?.id).filter(Boolean)).size;
  const enseignantCount = new Set(emploi.cours.map(c => c.enseignant?.id).filter(Boolean)).size;

  return (
    <div className="mb-6 print:hidden">
      <div className="bg-gray-50 rounded-lg p-4 border border-gray-200">
        <div className="flex items-center gap-2 mb-3">
          <BarChart size={20} className="text-gray-600" />
          <h4 className="font-semibold text-gray-800">Statistiques de l'emploi du temps</h4>
        </div>
        <div className="grid grid-cols-3 gap-4 text-center">
          <div className="bg-white p-3 rounded-lg border">
            <div className="text-2xl font-bold text-blue-600">{emploi.cours.length}</div>
            <div className="text-sm text-gray-600">Cours total</div>
          </div>
          <div className="bg-white p-3 rounded-lg border">
            <div className="text-2xl font-bold text-green-600 flex items-center justify-center gap-1">
              <Book size={20} />
              {moduleCount}
            </div>
            <div className="text-sm text-gray-600">Modules</div>
          </div>
          <div className="bg-white p-3 rounded-lg border">
            <div className="text-2xl font-bold text-purple-600 flex items-center justify-center gap-1">
              <Users size={20} />
              {enseignantCount}
            </div>
            <div className="text-sm text-gray-600">Enseignants</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmploymentStats; 